import TableStore                    from '@widesk-ui/stores/TableStore';
import React                         from 'react';
import View                          from '@widesk-ui/components/View';
import Button                        from '@widesk-ui/components/Button';
import { ArrowDownOutlined }         from '@ant-design/icons';
import { ArrowUpOutlined }           from '@ant-design/icons';
import { HolderOutlined }            from '@ant-design/icons';
import InputNumber                   from '@widesk-ui/components/form/InputNumber';
import type { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities';
import ListStore                     from '@widesk-ui/stores/ListStore';
import './DragHandle.scss';

interface RowContextProps {
	setActivatorNodeRef?: (element: HTMLElement | null) => void;
	listeners?: SyntheticListenerMap;
}

export default function DragHandle<T extends TableStore | ListStore>({
	datum,
	disabledArrows,
	onChange,
	store,
	RowContext,
}: {
	RowContext: ReturnType<typeof React.createContext<RowContextProps>>;
	datum: { position: number; };
	disabledArrows?: boolean;
	onChange?: (data: {
		position: number;
		oldPosition: number;
		store: T;
	}) => void;
	store: T;
}) {
	const { setActivatorNodeRef, listeners } = React.useContext(RowContext);

	const [value, setValue] = React.useState(datum.position + 1);

	React.useEffect(() => {
		setValue(datum.position + 1);
	}, [datum.position]);

	const oldPosition = datum.position;
	const maxPosition = store.total || store.data.length; // total si pagedCollection, sinon length de ApiCollection
	const isDesc = store.filters['sortWay'] === 'desc';

	const submit = (e: any) => {
		const newPosition = Number(e.target.value) - 1;

		if (newPosition !== oldPosition) {
			onChange?.({ position: newPosition, oldPosition, store });
		}
	};

	return (
		<View row gap="xxs" centerV>
			{!disabledArrows && (
				<div ref={setActivatorNodeRef} {...listeners}>
					<Button
						type="text"
						size="small"
						icon={<HolderOutlined />}
						style={{ cursor: 'move' }}
						children={null}
					/>
				</div>
			)}

			<InputNumber
				value={value}
				size="small"
				min={1}
				max={disabledArrows ? undefined : maxPosition}
				onPressEnter={submit}
				onChange={v => setValue(v as number)}
				onBlur={submit}
				className="drag-handle_position-input-number"
				controls={false}
			/>

			{!!onChange && !disabledArrows && (
				<>
					<Button
						type="text"
						size="small"
						icon={<ArrowUpOutlined />}
						children={null}
						disabled={(oldPosition === maxPosition - 1 && isDesc) || (oldPosition === 0 && !isDesc)}
						onClick={() => onChange({ position: oldPosition + (isDesc ? 1 : -1), oldPosition, store })}
					/>

					<Button
						type="text"
						size="small"
						icon={<ArrowDownOutlined />}
						children={null}
						disabled={(oldPosition === 0 && isDesc) || (oldPosition === maxPosition - 1 && !isDesc)}
						onClick={() => onChange({ position: oldPosition + (isDesc ? -1 : 1), oldPosition, store })}
					/>
				</>
			)}
		</View>
	);
}